import type { ParsedRecord } from "@/features/patient/records/api/dataPipelineApi";

export interface InsuranceSummary {
  name: string;
  planType: string;
  memberId: string;
  groupNumber: string; // "" if unknown
  startDate: string; // ISO yyyy-mm-dd, "" if unknown
  endDate: string; // ISO yyyy-mm-dd, "" if unknown
  isActive: boolean;
}

function toDateOnly(value: unknown): string {
  return typeof value === "string" ? value.slice(0, 10) : "";
}

function isActiveStatus(status: unknown): boolean {
  // Same bias as adaptMedication: ambiguous/blank status defaults to active
  // rather than silently hiding real coverage.
  if (typeof status !== "string") return true;
  const s = status.toLowerCase();
  return !(s.includes("cancel") || s.includes("terminat") || s.includes("inactive") || s.includes("expired"));
}

export function adaptCoverage(record: ParsedRecord): InsuranceSummary {
  const f = record.fields;
  return {
    name: (f.payor_name as string) || "Insurance Provider",
    planType: (f.plan_name as string) || (f.class_type_text as string) || (f.coverage_type as string) || "Plan",
    memberId: (f.subscriber_id as string) || "Unknown",
    groupNumber: (f.group_number as string) || "",
    startDate: toDateOnly(f.start_date),
    endDate: toDateOnly(f.end_date),
    isActive: isActiveStatus(f.status),
  };
}
